module.exports = __webpack_public_path__ + "static/media/banner-video.ed645fd.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/banner-video.mp4
// module id = mjuC
// module chunks = 0